<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Planejamento de Safra
    </div>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <span>Filtros</span>
          </v-card-title>
          <v-card-text>
            
              <!-- <v-col cols="12"> -->
                <v-autocomplete
                  v-model="harvestId"
                  label="Safra"
                  :items="harvestList"
                  item-value="id"
                  item-text="name"
                  @change="loadHarvestPlanningReport"
                />
              <!-- </v-col> -->
            
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <!-- <v-col cols="12"> -->
        <div>
          <BasePrint
            printableElementId="harvestPlanningReportTable"
            printButtonLabel="Imprimir"
            printTitle="Relatório de Planejamento de Safra"
            @start-printing="printing = loading = true"
            @stop-printing="printing = loading = false"
            v-if="harvestPlanning"
            class="my-3"
          />
        </div>
      <!-- </v-col> -->
    </v-row>

    <!-- <div > -->
      <!-- {{this.harvestPlanning}} -->
    <div id="harvestPlanningReportTable" v-if="harvestPlanning">
      <v-row >

        <v-col cols="12" sm="6">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Safra</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-h6">
                {{harvestPlanning.name}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Status</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-h6">
                {{harvestPlanning.status}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" class="">

          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="periodsHeaders"
            :table-items="harvestPlanning.periods.items"
            :indexNested="true"
            :maskFields="periodsHeadersMaskFields"
            :disablePagination="true"
            :containSearchBar="false"
            :hasTableTitle="true"
            :containTopToolbar="false"
            tableTitle="Ciclos Planejados"
          >

            <template slot="tableFooter">
              <tr class="d-none d-md-table-row">
                <td colspan="4"><strong class="title">Totais</strong></td>
                <td colspan="2" class="title"><strong>{{ this.harvestPlanning.periods.profit | formatCurrency }}</strong></td>
                <td colspan="1" class="title"><strong>{{ this.harvestPlanning.periods.cost | formatCurrency }}</strong></td>
                <td colspan="1" class="title"><strong>{{ this.harvestPlanning.estimatedResult | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Total de Ganhos</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.harvestPlanning.periods.profit | formatCurrency }}</strong></div>
                </td>

                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Total de Custos</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.harvestPlanning.periods.cost | formatCurrency }}</strong></div>
                </td>

                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Resultado Estimado</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.harvestPlanning.estimatedResult | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>

          </BaseIndex>

        </v-col>


        <v-col cols="12" class="">

          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="planningItemsHeaders"
            :table-items="harvestPlanning.planningItems.items"
            :indexNested="true"
            :maskFields="planningItemsHeadersMaskFields"
            :disablePagination="true"
            :containSearchBar="false"
            :hasTableTitle="true"
            :containTopToolbar="false"
            tableTitle="Itens Planejados de Operações"
          >

            <template slot="tableFooter">
              <tr class="d-none d-md-table-row">
                <td colspan="4"><strong class="title">Valor Total dos Itens de Operações</strong></td>
                <td colspan="1" class="text-xs-right title"><strong>{{ this.harvestPlanning.planningItems.cost | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Valor Total dos Itens de Operações</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.harvestPlanning.planningItems.cost | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>

          </BaseIndex>

        </v-col>

        <v-col cols="12" class="">

          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="employeesHeaders"
            :table-items="harvestPlanning.employees.items"
            :indexNested="true"
            :maskFields="employeesHeadersMaskFields"
            :disablePagination="true"
            :containSearchBar="false"
            :hasTableTitle="true"
            :containTopToolbar="false"
            tableTitle="Funcionários Planejados"
          >

            <template slot="tableFooter">
              <tr class="d-none d-md-table-row">
                <td colspan="3"><strong class="title">Valor Total dos Funcionários</strong></td>
                <td colspan="1" class="text-xs-right title"><strong>{{ this.harvestPlanning.employees.cost | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Valor Total dos Funcionários</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.harvestPlanning.employees.cost | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>

          </BaseIndex>

        </v-col>

        <v-col cols="12" class="">

          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="patrimoniesHeaders"
            :table-items="harvestPlanning.machinery.items"
            :indexNested="true"
            :maskFields="patrimoniesHeadersMaskFields"
            :disablePagination="true"
            :containSearchBar="false"
            :hasTableTitle="true"
            :containTopToolbar="false"
            tableTitle="Patrimônios Planejados"
          >

            <template slot="tableFooter">
              <tr class="d-none d-md-table-row">
                <td colspan="5"><strong class="title">Valor Total dos Patrimônios</strong></td>
                <td colspan="1" class="text-xs-right title"><strong>{{ this.harvestPlanning.machinery.cost | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Valor Total dos Patrimônios</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.harvestPlanning.machinery.cost | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>

          </BaseIndex>

        </v-col>

        <v-col cols="12" class="">
          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="planningProductsHeaders"
            :table-items="harvestPlanning.planningProducts.items"
            :indexNested="true"
            :maskFields="planningProductsHeadersMaskFields"
            :disablePagination="true"
            :containSearchBar="false"
            :containTopToolbar="false"
            :hasTableTitle="true"
            tableTitle="Produtos Produzidos Planejados"
          >

            <!-- <template slot="tableFooter">
              <tr>
                <td colspan="3"><strong class="title">Total dos Itens Consumidos</strong></td>
                <td colspan="1" class="text-xs-right title"><strong>{{ executionOperation.consumedItemsTotalPrice | formatCurrency }}</strong></td>
              </tr>
            </template> -->

          </BaseIndex>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Ganho Estimado</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-h6">
                {{numberToCurrency(harvestPlanning.periods.profit)}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Custo Estimado</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-h6">
                {{numberToCurrency(harvestPlanning.estimatedCost)}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Resultado Estimado</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-h6">
                {{numberToCurrency(harvestPlanning.estimatedResult)}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>
    </div>
    <!-- </div> -->
    
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      tableItems: [],
      harvestPlanning: null,
      loading: false,
      pageLoading: false,
      harvestListLoading: false,
      harvestList: [],
      harvestId: null,
      periodsHeaders: [
        { text: 'Talhão', sortable: true, value: 'name' },
        { text: 'Área', sortable: true, value: 'area' },
        { text: 'Produtividade Esperada', sortable: true, value: 'expectedProductivity' },
        { text: 'R$/Kg Estimado', sortable: true, value: 'estimatedPrice' },
        { text: 'Ganho Estimado', sortable: true, value: 'profit' },
        { text: 'Custo por Ha', sortable: true, value: 'costByHa' },
        { text: 'Custo Total', sortable: true, value: 'cost' },
        { text: 'Resultado Estimado', sortable: true, value: 'estimatedResult' },
        
      ],
      periodsHeadersMaskFields: [
        { field: 'area', mask: 'number_unit', unit: 'ha'},
        { field: 'expectedProductivity', mask: 'number_unit', unit: 'Kg/ha'},
        { field: 'estimatedPrice', mask: 'currency' },
        { field: 'profit', mask: 'currency' },
        { field: 'costByHa', mask: 'currency' },
        { field: 'cost',mask: 'currency'},
        { field: 'estimatedResult',mask: 'currency'},
      ],
      planningItemsHeaders: [
        { text: 'Item', sortable: true, value: 'name' },
        { text: 'Quantidade Total', sortable: true, value: 'quantity' },
        { text: 'Quantidade em Estoque', sortable: true, value: 'stockQuantity' },
        { text: 'Preço Unit.', sortable: true, value: 'unitPrice' },
        { text: 'Preço Total', sortable: true, value: 'cost' },
      ],
      planningItemsHeadersMaskFields: [
        { field: 'unitPrice', mask: 'currency_10d' },
        { field: 'quantity', mask: 'number'},
        { field: 'stockQuantity', mask: 'number'},
        { field: 'cost',mask: 'currency'}
      ],
      planningProductsHeaders: [
        { text: 'Produto', sortable: true, value: 'name' },
        { text: 'Quantidade Produzida', sortable: true, value: 'quantity' },
      ],
      planningProductsHeadersMaskFields: [
        { field: 'quantity', mask: 'number_unit', unit: 'Kg' },
      ],
      employeesHeaders: [
        { text: 'Colaborador', sortable: true, value: 'name' },
        { text: 'Tempo de Trabalho', sortable: true, value: 'workTime' },
        { text: 'Valor Hora', sortable: true, value: 'hourlyPrice' },
        { text: 'Valor Total', sortable: true, value: 'cost' },
      ],
      employeesHeadersMaskFields: [
        { field: 'hourlyPrice', mask: 'currency'},
        { field: 'cost',mask: 'currency'}
      ],
      patrimoniesHeaders: [
        { text: 'Patrimônio', sortable: true, value: 'patrimonyName' },
        { text: 'Valor Hora Pat.', sortable: true, value: 'patrimonyHourlyPrice' },
        { text: 'Implemento', sortable: true, value: 'implementName' },
        { text: 'Valor Hora Imp.', sortable: true, value: 'implementHourlyPrice' },
        { text: 'Tempo', sortable: true, value: 'totalTime' },
        { text: 'Valor Total', sortable: true, value: 'cost' },
      ],
      patrimoniesHeadersMaskFields: [
        { field: 'patrimonyHourlyPrice', mask: 'currency'},
        { field: 'implementHourlyPrice', mask: 'currency'},
        { field: 'cost',mask: 'currency'}
      ],
    };
  },
  props: {
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
  },
  created() {
    this.loadAllHarvests();
  },
  mounted() { 
  },
  computed: {
    tableHeaders: function () { }
  },
  methods: {
    loadHarvestPlanningReport: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_HARVEST_PLANNING_REPORT,
          variables: {
            harvestId: this.harvestId
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.harvestPlanning = response.data.accountContext.harvestPlanningReport;
          // console.log("harvestPlanning", this.harvestPlanning);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    loadAllHarvests: function() {
        this.harvestListLoading = true;
        this.$apollo
          .query({
            query: LOAD_ALL_HARVEST_QUERY,
            fetchPolicy: "no-cache"
          })
          .then(response => {
            this.harvestList = response.data.accountContext.allHarvests;
          })
          .catch(response => console.log(response))
          .finally(() => (this.harvestListLoading = false));
    },
  }
};



const LOAD_HARVEST_PLANNING_REPORT = gql `
query ($harvestId: ID!) {
  accountContext {
    harvestPlanningReport(harvestId: $harvestId)
  }
}
`;

const LOAD_ALL_HARVEST_QUERY = gql `
  {
    accountContext {
      allHarvests {
        id
        name
      }
    }
  }
`;


</script>

<style scoped>
  ::v-deep .cash_inflow_item {
    color: blue;
  }
  ::v-deep .cash_outflow_item {
    color: red;
  }
  ::v-deep .group_type {
    background-color: #ffdc9d;
    font-weight: bold;
  }
  ::v-deep .direct_cost {
    background-color: #60bd60;
    font-weight: bold;
  }
  ::v-deep .indirect_cost {
    background-color: #60bd60;
    font-weight: bold;
  }

  ::v-deep .total_cost {
    background-color: red;
    color: white;
    font-weight: bold;
  }
  ::v-deep .total_cost:hover {
    color: black;
  }
  
  ::v-deep .area_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .area_cost:hover {
    color: black;
  }

  ::v-deep .unit_production_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .unit_production_cost:hover {
    color: black;
  }
  
  ::v-deep .unit_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .unit_cost:hover {
    color: black;
  }
  
  
  ::v-deep .total_revenue {
    background-color: #007eff;
    color: white;
    font-weight: bold;
  }
  ::v-deep .total_revenue:hover {
    color: black;
  }

  ::v-deep .period_result {
    background-color: yellow;
  }

  ::v-deep .area_result {
    background-color: yellow;
  }
  ::v-deep .unit_result {
    background-color: yellow;
  }
  ::v-deep .net_income {
    background-color: yellow;
  }
</style>
